/* eslint-disable react/require-default-props */

//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Breadcrumb } from "semantic-ui-react";
import { jsx as _jsx } from "react/jsx-runtime";
const ApplicationBreadcrumbSection = props => {
  const {
    children,
    libelle
  } = props;
  return /*#__PURE__*/_jsx(Breadcrumb.Section, {
    "data-sentry-element": "unknown",
    "data-sentry-component": "ApplicationBreadcrumbSection",
    "data-sentry-source-file": "ApplicationBreadcrumbSection.tsx",
    children: /*#__PURE__*/_jsx(SwitchTransition, {
      "data-sentry-element": "SwitchTransition",
      "data-sentry-source-file": "ApplicationBreadcrumbSection.tsx",
      children: /*#__PURE__*/_jsx(CSSTransition, {
        addEndListener: (node, done) => node.addEventListener("transitionend", done, false),
        classNames: "fade",
        "data-sentry-element": "CSSTransition",
        "data-sentry-source-file": "ApplicationBreadcrumbSection.tsx",
        children: /*#__PURE__*/_jsx("span", {
          "data-testid": `section${libelle ? `.${libelle}` : ""}`,
          children: libelle || children
        })
      }, libelle)
    })
  });
};
export default ApplicationBreadcrumbSection;